import {
    FvBoxPortDataRelationAnchor,
    FvBoxPortDataRelationVersion,
} from 'src/models/anchor-and-version/fv-box-port-data-relation.model';
import { createBaseAnchor, createBaseVersion } from './base.factory';
import { deepCopy, getDistinctArr } from 'src/utils/other.util';
import { CanPortDataAnchor } from 'src/models/anchor-and-version/can-port-data.model';
import { DirectWirePortDataAnchor } from 'src/models/anchor-and-version/direct-wire-port-data.model';
import { InternalPortDataAnchor } from 'src/models/anchor-and-version/internal-port-data.model';

export function createFvBoxPortDataRelationAnchor(
    aParams: {
        // Base
        logText: string;
        // Specific
        fvBoxAnchorKey: number;
        canPortDataAnchorKey?: number;
        directWirePortDataAnchorKey?: number;
        internalPortDataAnchorKey?: number;
        // Virtual
        canPortDataAnchor?: CanPortDataAnchor;
        directWirePortDataAnchor?: DirectWirePortDataAnchor;
        internalPortDataAnchor?: InternalPortDataAnchor;
    },
    vParams: {
        // Base
        changeRequestKey: number;
        comment: string;
        logText: string;
        name: string;
        // Specific
        isRxActive: boolean;
        isTxActive: boolean;
    }
): FvBoxPortDataRelationAnchor {
    const validVersion = createFvBoxPortDataRelationVersion({ ...vParams, anchorKey: 0 });
    const firstVersion = deepCopy(validVersion);
    firstVersion.isRxActive = false;
    firstVersion.isTxActive = false;
    firstVersion.changeRequestKey = 1;
    const versions = getDistinctArr([firstVersion, validVersion]);
    const anchor: FvBoxPortDataRelationAnchor = {
        ...createBaseAnchor(aParams),
        fvBoxAnchorKey: aParams.fvBoxAnchorKey,
        canPortDataAnchorKey: aParams.canPortDataAnchorKey ?? null,
        directWirePortDataAnchorKey: aParams.directWirePortDataAnchorKey ?? null,
        internalPortDataAnchorKey: aParams.internalPortDataAnchorKey ?? null,
        canPortDataAnchor: aParams.canPortDataAnchor ?? null,
        directWirePortDataAnchor: aParams.directWirePortDataAnchor ?? null,
        internalPortDataAnchor: aParams.internalPortDataAnchor ?? null,
        displayName: null,
        allVersions: versions,
        validVersion: validVersion,
    };

    return anchor;
}

export function createFvBoxPortDataRelationVersion(params: {
    // Base
    anchorKey: number;
    changeRequestKey: number;
    comment: string;
    logText: string;
    name: string;
    // Specific
    isRxActive: boolean;
    isTxActive: boolean;
}): FvBoxPortDataRelationVersion {
    const baseVersion = createBaseVersion(params);
    const version: FvBoxPortDataRelationVersion = {
        ...baseVersion,
        isRxActive: params.isRxActive,
        isTxActive: params.isTxActive,
    };

    return version;
}
